module.exports = __webpack_public_path__ + "img/mxfx.6b770fb.png";